// extracted by mini-css-extract-plugin
module.exports = {"root":"Preview_root__DUDEd"};